import React from "react";
import {Box, Stack} from "@mui/material";
import {styles} from "../../MetricsDetail/MetricsDetailsStyles";
import {PageTitle} from "../../MetricsDetail/PageTitle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DateRangeForm from "../../MetricsDetail/Forms/DateRangeForm";
import TuneIcon from "@mui/icons-material/Tune";
import {MetricsDetailFilter} from "../../MetricsDetail/MetricsDetailFilter";
import {pageFilterToDropdownMapping} from "../../MetricsDetail/MetricsDetailUtils";
import {CampaignNamesDropdown} from "../CampaignNamesDropdown";
import BasicActionButton from "../../../../v3/common/BasicActionButton";
import moduleStyles from "../Utilities/styles.module.css"
import {RETAIN_CAMPAIGNS} from "../../RetainDashboard/Utilities/CampaignUtils";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import _ from "lodash";
import useLocationQueryParams from "../../../hooks/useLocationQueryParams";
import {objectToQueryString} from "../../../../../_helpers";

export const HeaderFormFields = ({
                                     isFilterDropdownOpen,
                                     setIsFilterDropdownOpen,
                                     isCampaignNameDropdownOpen,
                                     setIsCampaignNameDropdownOpen,
                                     selectedCriteria,
                                     setSelectedCriteria,
                                     filterRef,
                                     filterPageRef,
                                     handleExport,
                                     pageFilter,
                                     selectedDropdownOption,
                                     onSelectChangeHandler,
                                     onFilterFormSubmit,
                                     handleFilterReset,
                                     dateRange,
                                     setDateRange,
                                     extractedCampaignList,
                                     setLiked,
                                     setReplied,
                                     setNoEngagement,
                                     setFollowed,
                                     setConverted,
                                     setFollowUpSent,
                                     setConvertedAfterFollowUpSent,
                                     setHasAdditionalOrders,
                                     setOrderedWithin5Days,
                                     setOrderedRecommendedCategory,
                                     setOrderedRecommendedProduct,
                                     setUsedDiscount,
                                     setUsedExactDiscountCode,
                                     setLastTouch,
                                 }) => {
    const filterDropdownComponent = pageFilterToDropdownMapping({
        selectedCriteria,
        setSelectedCriteria,
        setLiked,
        setReplied,
        setNoEngagement,
        setFollowed,
        setConverted,
        setFollowUpSent,
        setConvertedAfterFollowUpSent,
        setHasAdditionalOrders,
        setOrderedWithin5Days,
        setOrderedRecommendedCategory,
        setOrderedRecommendedProduct,
        setUsedDiscount,
        setUsedExactDiscountCode,
        setLastTouch,
        pageFilter
    })[pageFilter];
    const { params } = useLocationQueryParams();
    const { organizationId, campaignIds, pageFilter: _pageFilter, source } = params;
    const summaryReportLink = `/summary-report?${objectToQueryString({organizationId, campaignIds, pageFilter: _pageFilter, source, campaignName: selectedDropdownOption?.name})}`

    return (
        <Stack direction={{xs: 'column', lg: 'row'}} sx={styles.headerFormField} spacing={1}>
            <PageTitle pageFilter={pageFilter} />

            <Stack
                direction={{xs: 'column', md: 'row'}}
                gap={{xs: '12px', md: '0px'}}
                sx={{width: {xs: '100%', md: '70%'}, justifyContent: 'flex-end'}}
            >
                <Box className='position-relative' ref={filterPageRef}>
                    <button
                        className={moduleStyles.campaignsDropwdownButton}
                        type="button"
                        onClick={() => setIsCampaignNameDropdownOpen(!isCampaignNameDropdownOpen)}
                    >
                        <span className={moduleStyles.campaignsDropwdownButtonText}>
                            {selectedDropdownOption?.name || 'Select campaign'}
                        </span>
                        <ArrowDropDownIcon sx={styles.arrowDownIcon}/>
                    </button>
                    {isCampaignNameDropdownOpen &&
                        <CampaignNamesDropdown
                            selectedDropdownOption={selectedDropdownOption}
                            onSelectChangeHandler={onSelectChangeHandler}
                            dropdownOptions={extractedCampaignList}
                        />
                    }
                </Box>

                <Box sx={{width: {xs: '100%', sm: 'auto'}, marginRight: '12px'}}>
                    <DateRangeForm
                        startDate={dateRange.startDate}
                        endDate={dateRange.endDate}
                        setDates={setDateRange}
                    />
                </Box>
                <div ref={filterRef} className="position-relative">
                    <button
                        className="metricsDetailsFilter"
                        type="button"
                        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}>
                        <TuneIcon sx={styles.tuneIcon}
                        />
                        Filters
                        <ArrowDropDownIcon sx={styles.arrowDownIcon}/>
                    </button>
                    {isFilterDropdownOpen && <MetricsDetailFilter
                        filterDropDown={filterDropdownComponent}
                        onFilterFormSubmit={onFilterFormSubmit}
                        handleFilterReset={handleFilterReset}
                    />}
                </div>
                {pageFilter === RETAIN_CAMPAIGNS &&
                    <Box sx={styles.viewSummaryButton}>
                        <a href={summaryReportLink} className={moduleStyles.buttonBordered}>
                           <AutoAwesomeIcon sx={{fontSize: "15px", color: "#74c4ec"}} /> View Summary Report
                        </a>
                    </Box>
                }
                {
                    handleExport
                        ? (
                            <Box ml='12px'>
                                <BasicActionButton label={'Export'} sx={styles.exportButton} action={handleExport} />
                            </Box>
                        )
                        : ""
                }
            </Stack>
        </Stack>
    )
}
